<!-- Migrated from legacy/Plus/Plus/2017/Events/index.shtml (exhibit section) -->

<template>
  <h3>
    <span style="font-weight: 200">'VizbiPlus Exhibit: A Showcase of Science-Inspired
      Artwork'</span>
  </h3>
  <h4>5&ndash;8pm, Monday 29 May 2017 &mdash; Spunky Bruiser Store, Darlinghurst, Sydney</h4>
  <p>
    The opening evening of the first exhibit of original artwork inspired by a series of
    cutting-edge scientific discoveries. The showcased artworks were selected submissions from
    the <router-link to="/Plus/Challenge">VizbiPlus Challenge</router-link>, a competition
    created to encourage local artists to draw inspiration from science to produce original,
    novel, engaging and insightful art pieces.
  </p>
  <a
    href="/Showcase/2017/Gallery_popArt.png"
    title="Art For Science Gallery Pop Art by Benedetta Frida Baldi">
    <img
      class="banner"
      src="/Showcase/2017/fb_cover851by315.png"
      alt="VizbiPlus Exhibit; credits: Benedetta Frida Baldi" />
  </a>
  <p>
    During the evening, visitors had the opportunity to meet the artists and scientists and
    engage in conversations about their inspirations. The exhibit remained open for the entire
    length of Vivid, with the challenge winner announced at the
    <router-link to="/2017/Showcase/Evening">main evening event</router-link>.
  </p>
  <p>
    The exhibit was a joint collaboration between the Spunky Bruiser Store and the
    <a href="https://www.garvan.org.au/">VIZBI lab from the Garvan Institute of Medical
      Research</a>
    and <a href="https://data61.csiro.au/">CSIRO's Data61</a>.
  </p>
</template>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  clear: both;
}
img.banner {
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}
</style>
